import React, { FC, Fragment } from 'react';

import SlotStake from './SlotStake';

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyType = any;

type CorrectScoreProps = {
  [key: string]: AnyType;
  // TODO: write types, if you have some free time please :)
  // stakes: PropTypes.object.isRequired,
  slotStakeDataGaEvent: string;
};

const DefaultSlotContentComponent: FC<CorrectScoreProps> = ({ stakes, slotStakeDataGaEvent }) => {
  return stakes.map((stake: AnyType) => (
    <Fragment key={stake.id}>
      <SlotStake stake={stake}
                 key={stake.id}
                 dataGaEvent={slotStakeDataGaEvent} />
    </Fragment>
  ));
};

export default DefaultSlotContentComponent;
